module.exports = __webpack_public_path__ + "img/subheader01_top.e3ac6cde.jpg";